// Root portal dashboard — branches by role: client (cream) or team/super_admin (dark).
// super_admin gets the new Command Center; regular team gets the classic editor's desk.
import { usePortalAuth } from "./PortalAuth";
import ClientView from "./ClientView";
import TeamView from "./TeamView";
import CommandCenter from "./CommandCenter";

export default function PortalDashboard() {
  const { user } = usePortalAuth();
  if (!user) return null;
  if (user.role === "client") return <ClientView user={user} />;
  if (user.role === "super_admin") return <CommandCenter user={user} />;
  return <TeamView user={user} />;
}
